import { useContext } from "react";

import { useTranslation } from "react-i18next";

import { Card } from "components/Dashboard/components/Card";
import ParamsContext from "context/params/paramsContext";

import Level from "./Level";
import ResourceLimits from "./ResourceLimits";

const CompanyLevel = () => {
    const { rootCompanyLevel } = useContext(ParamsContext);

    const { t } = useTranslation();

    return (
        <Card title={t("General##company level")}>
            <Level level={rootCompanyLevel} />
            <ResourceLimits />
        </Card>
    );
};

export default CompanyLevel;
